export default function polyfills() {
  /*
   * canvas.toBlob polyfill
   * stolen from croppie
   * https://github.com/Foliotek/Croppie/blob/b442a7dfc6169b96e3e10960e6ef3d518a7fdea2/croppie.js#L39-L53
   */

  if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function (callback, type, quality) {
        let binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
          len = binStr.length,
          arr = new Uint8Array(len);

        for (let i=0; i<len; i++ ) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback(new Blob([arr], { type: type || 'image/png' }));
      }
    });
  }
}
